import { render, staticRenderFns } from "./InviteJoin.vue?vue&type=template&id=253c3163&scoped=true"
import script from "./InviteJoin.vue?vue&type=script&lang=js"
export * from "./InviteJoin.vue?vue&type=script&lang=js"
import style0 from "./InviteJoin.vue?vue&type=style&index=0&id=253c3163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c3163",
  null
  
)

export default component.exports